const filters = {
    grayscale: 'grayscale(1)',
    sepia: 'sepia(1)',
    invert: 'invert(.8)',
    blur: 'blur(2px)',
};
let filterCanvas;
let filterCtx;
/**
 * Aplikuje filtr na vrstvu
 * @param layer
 * @param filter
 */
export const layerCanvasFilter = (layer, // ol.layer.Layer,
filter) => {
    if (!layer || !filter) {
        return;
    }
    if (!filterCanvas) {
        filterCanvas = document.createElement('canvas');
        filterCanvas.style.display = 'none';
        document.body.appendChild(filterCanvas);
        filterCtx = filterCanvas.getContext('2d');
    }
    const canvasFilter = createFilter(getFilter(filter));
    canvasFilter && layer.on('postrender', (e) => canvasFilter(e.context));
    return canvasFilter;
};
/**
 * Dle nazvu filtru vytvori funkci, ktere aplikuje pozadovany filtr
 * @param filter
 */
const createFilter = (filter) => {
    if ((filterCtx && 'filter' in filterCtx) || !filter.effect) {
        return filterContext.bind(null, filter);
    }
    const match = filter.effect.match(/^(grayscale|invert|sepia)(\(([\d.]+)%?\))?$/);
    if (match) {
        return filterImage.bind(null, match[1], +match[3]);
    }
};
/**
 * Aplikuje filtr na canvas, pokud to canvas touto metodou podporuje
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D
 * @param filter
 * @param context
 */
const filterContext = (filter, context) => {
    const canvas = context.canvas;
    filterCanvas.width = canvas.width;
    filterCanvas.height = canvas.height;
    if (filter.fillStyle) {
        filterCtx.beginPath();
        filterCtx.rect(0, 0, canvas.width, canvas.height);
        filterCtx.fillStyle = filter.fillStyle;
        filterCtx.fill();
    }
    else {
        filterCtx.clearRect(0, 0, canvas.width, canvas.height);
    }
    filter.operation && (filterCtx.globalCompositeOperation = filter.operation);
    filter.alpha && (filterCtx.globalAlpha = filter.alpha);
    filter.effect && (filterCtx.filter = filter.effect);
    filterCtx.drawImage(canvas, 0, 0, canvas.width, canvas.height);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(filterCanvas, 0, 0, canvas.width, canvas.height);
};
/**
 * Aplikuje filter na canvas pomalejsi metodou vhodnou pro IE
 * @param filter
 * @param param
 * @param context
 */
const filterImage = (filter, param, context) => {
    const canvas = context.canvas;
    let idata;
    try {
        idata = context.getImageData(0, 0, canvas.width, canvas.height);
    }
    catch (e) {
        console.warn(e);
        return;
    }
    const data = idata.data;
    const k = (param > 1 ? param / 100 : param) || 1;
    for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        if (filter === 'grayscale') {
            const p = Math.sqrt(r * r * 0.299 + g * g * 0.587 + b * b * 0.114);
            data[i] = p + (r - p) * (1 - k);
            data[i + 1] = p + (g - p) * (1 - k);
            data[i + 2] = p + (b - p) * (1 - k);
        }
        else if (filter === 'invert') {
            data[i] = r + r * (255 - 2) * k;
            data[i + 1] = g + g * (255 - 2) * k;
            data[i + 2] = b + b * (255 - 2) * k;
        }
        else if (filter === 'sepia') {
            const tr = Math.round(r * 0.393 + g * 0.769 + b * 0.189);
            const tg = Math.round(r * 0.349 + g * 0.686 + b * 0.168);
            const tb = Math.round(r * 0.272 + g * 0.534 + b * 0.131);
            data[i] = tr > 255 ? 255 : tr;
            data[i + 1] = tg > 255 ? 255 : tg;
            data[i + 2] = tb > 255 ? 255 : tb;
        }
    }
    context.putImageData(idata, 0, 0);
};
const getFilter = (filter) => {
    let filterData = {
        effect: '',
        fillStyle: '',
        operation: '',
        alpha: 1,
    };
    typeof filter === 'string' ? (filterData.effect = filter) : (filterData = filter);
    filterData.effect = filters[filterData.effect] || filterData.effect;
    return filterData;
};
//# sourceMappingURL=canvasFilter.js.map